import { useEffect, ReactNode } from 'react'

import Providers from './providers'

import Toast from 'common/components/toast/Toast'
import HotjarHelper from 'common/helpers/hotjar'
import ErrorBoundary from 'common/components/errorBoundary'
import useSetLanguage from 'common/hooks/useSetLanguage'
import useFetchUserByToken from 'modules/auth/hooks/useFetchUserByToken'
import Loading from 'common/components/loading/Loading'
import GlobalStyles from 'common/styles/global'

interface Props {
  children: ReactNode
}

const AppWrapper = ({ children }: Props) => {
  const { user, loading } = useFetchUserByToken()

  const i18next = useSetLanguage(user)

  useEffect(() => {
    HotjarHelper.dispatchLanguageTrigger()
  }, [])

  return (
    <ErrorBoundary>
      <Providers>
        <GlobalStyles />
        {
          loading || i18next.isLoading
            ? <Loading full />
            : children
        }
        <Toast />
      </Providers>
    </ErrorBoundary>
  )
}

export default AppWrapper
